import { Injectable } from '@angular/core';
import { AuthService } from "@app/common/services/auth.service";
import { ProjectTypesEnum } from "@app/ps/enums/project-types.enum";

@Injectable({ providedIn: 'root' })
export class ApproveFinalSolutionTypeService {

  constructor(
    private authService: AuthService,
  ) { }

  public canApproveFinalSolutionType(): boolean {
    if (this.authService.getActualProject().type === ProjectTypesEnum.ADDITIONAL) {
      return this.authService.hasPermission('approve_final_solution') || this.authService.isManager();
    }

    if (this.authService.getActualProject().type === ProjectTypesEnum.INVEST) {
      return this.authService.isManager() || this.authService.hasPermission('admin');
    }

    return false;
  }
}
